"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoconRoot = void 0;

var _history = require("history");

var _react = _interopRequireWildcard(require("react"));

var _HistoryContext = require("../contexts/HistoryContext");

var _LocationContext = require("../contexts/LocationContext");

const RoconRoot = /*#__PURE__*/(0, _react.memo)(props => {
  const history = (0, _react.useMemo)(() => props.history || (0, _history.createBrowserHistory)(), [props.history]);
  const historyContextValue = (0, _react.useMemo)(() => {
    return {
      history
    };
  }, [history]);
  const [location, setLocation] = (0, _react.useState)(history.location);
  (0, _react.useEffect)(() => {
    return history.listen(state => {
      setLocation(state.location);
    });
  }, [history]);
  return /*#__PURE__*/_react.default.createElement(_HistoryContext.HistoryContext.Provider, {
    value: historyContextValue
  }, /*#__PURE__*/_react.default.createElement(_LocationContext.LocationContext.Provider, {
    value: location
  }, props.children));
});
exports.RoconRoot = RoconRoot;